module.exports = __webpack_public_path__ + "static/media/pic_default2.118ab3db.png";